/** An inline gloss reads after its span as ` (gloss)` in the secondary text color; decoration, never selectable text. */
export const inlineGlossClassName = 'text-on-surface-secondary select-none'
